import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "spinner-full-page"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-full-page__worm" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "page bg-grey" }
const _hoisted_5 = { class: "row no-gutters" }
const _hoisted_6 = { class: "col-12" }
const _hoisted_7 = { class: "row no-gutters" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { id: "scroll-to-top" }, null, -1)
const _hoisted_9 = { class: "insurance-page" }
const _hoisted_10 = { class: "basket-header-container" }
const _hoisted_11 = { class: "vertical-flow-header" }
const _hoisted_12 = { class: "logo" }
const _hoisted_13 = {
  key: 0,
  href: "//www.almbrand.dk",
  title: "Til Alm. Brand forside"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "logo__icon" }, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "row no-gutters" }
const _hoisted_17 = { class: "col-12" }
const _hoisted_18 = {
  key: 0,
  class: "page__content vertical-app"
}
const _hoisted_19 = { class: "row no-gutters end-space" }
const _hoisted_20 = { class: "col-12 mb-6" }
const _hoisted_21 = {
  key: 0,
  class: "page__content vertical-app"
}
const _hoisted_22 = {
  key: 0,
  class: "vertical-app vertical-flow legal"
}
const _hoisted_23 = {
  key: 1,
  class: "vertical-app vertical-flow"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToggleModalComponent = _resolveComponent("ToggleModalComponent")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_PageTitleComponent = _resolveComponent("PageTitleComponent")!
  const _component_BasketWidgetComponent = _resolveComponent("BasketWidgetComponent")!
  const _component_buyCarComponent = _resolveComponent("buyCarComponent")!
  const _component_buyDogComponent = _resolveComponent("buyDogComponent")!
  const _component_buyTravelComponent = _resolveComponent("buyTravelComponent")!
  const _component_buyHomeComponent = _resolveComponent("buyHomeComponent")!
  const _component_buyHouseComponent = _resolveComponent("buyHouseComponent")!
  const _component_buyAccidentComponent = _resolveComponent("buyAccidentComponent")!
  const _component_buyAccidentChildrenComponent = _resolveComponent("buyAccidentChildrenComponent")!
  const _component_buyFamilyComponent = _resolveComponent("buyFamilyComponent")!
  const _component_BasketComponent = _resolveComponent("BasketComponent")!
  const _component_MessageComponent = _resolveComponent("MessageComponent")!
  const _component_ContactComponent = _resolveComponent("ContactComponent")!
  const _component_LinkComponent = _resolveComponent("LinkComponent")!
  const _component_usabillaInPageComponent = _resolveComponent("usabillaInPageComponent")!
  const _component_cookieFooter = _resolveComponent("cookieFooter")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.showSpinner)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    _createVNode(_component_ToggleModalComponent),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_ctx.menuModel)
            ? (_openBlock(), _createBlock(_component_Menu, {
                key: 0,
                model: _ctx.menuModel
              }, null, 8, ["model"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", {
              class: _normalizeClass(['vertical-flow-header-basket-page', { app: _ctx.isLoggedInAsApp }])
            }, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  (_ctx.model && !_ctx.menuModel)
                    ? (_openBlock(), _createElementBlock("a", _hoisted_13, _hoisted_15))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.model && _ctx.renderPage)
                  ? (_openBlock(), _createBlock(_component_PageTitleComponent, {
                      key: 0,
                      class: _normalizeClass([{ 'no-preTitle': _ctx.isLoggedInAsApp }, 'page__title--tiles']),
                      preTitle: _ctx.preTitle,
                      mainTitle: _ctx.mainTitle
                    }, null, 8, ["class", "preTitle", "mainTitle"]))
                  : _createCommentVNode("", true),
                (_ctx.productName && _ctx.cms)
                  ? (_openBlock(), _createBlock(_component_BasketWidgetComponent, {
                      key: 1,
                      showBasket: _ctx.cms.showBasket,
                      productName: _ctx.productName === 'kurv' ? undefined : _ctx.productName
                    }, null, 8, ["showBasket", "productName"]))
                  : _createCommentVNode("", true)
              ])
            ], 2)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          (_ctx.contentBlocksLoaded)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                (_ctx.isCar)
                  ? (_openBlock(), _createBlock(_component_buyCarComponent, {
                      key: 0,
                      contentUrl: _ctx.model.url,
                      calculatorInfoBlock: _ctx.calculatorInfoBlock,
                      contentBlocks: _ctx.contentBlocks,
                      cardReceipt: _ctx.receiptBlock,
                      settingsBlock: _ctx.settingsBlock,
                      campaignBlocks: _ctx.campaignBlocks,
                      headerCards: _ctx.headerCards,
                      usabillaBlock: _ctx.usabillaBlock
                    }, null, 8, ["contentUrl", "calculatorInfoBlock", "contentBlocks", "cardReceipt", "settingsBlock", "campaignBlocks", "headerCards", "usabillaBlock"]))
                  : (_ctx.isDog)
                    ? (_openBlock(), _createBlock(_component_buyDogComponent, {
                        key: 1,
                        contentUrl: _ctx.model.url,
                        calculatorInfoBlock: _ctx.calculatorInfoBlock,
                        contentBlocks: _ctx.contentBlocks,
                        cardReceipt: _ctx.receiptBlock,
                        settingsBlock: _ctx.settingsBlock,
                        campaignBlocks: _ctx.campaignBlocks,
                        headerCards: _ctx.headerCards,
                        usabillaBlock: _ctx.usabillaBlock
                      }, null, 8, ["contentUrl", "calculatorInfoBlock", "contentBlocks", "cardReceipt", "settingsBlock", "campaignBlocks", "headerCards", "usabillaBlock"]))
                    : (_ctx.isTravel)
                      ? (_openBlock(), _createBlock(_component_buyTravelComponent, {
                          key: 2,
                          contentUrl: _ctx.model.url,
                          calculatorInfoBlock: _ctx.calculatorInfoBlock,
                          contentBlocks: _ctx.contentBlocks,
                          cardReceipt: _ctx.receiptBlock,
                          settingsBlock: _ctx.settingsBlock,
                          campaignBlocks: _ctx.campaignBlocks,
                          headerCards: _ctx.headerCards,
                          usabillaBlock: _ctx.usabillaBlock
                        }, null, 8, ["contentUrl", "calculatorInfoBlock", "contentBlocks", "cardReceipt", "settingsBlock", "campaignBlocks", "headerCards", "usabillaBlock"]))
                      : (_ctx.isHome)
                        ? (_openBlock(), _createBlock(_component_buyHomeComponent, {
                            key: 3,
                            contentUrl: _ctx.model.url,
                            calculatorInfoBlock: _ctx.calculatorInfoBlock,
                            contentBlocks: _ctx.contentBlocks,
                            cardReceipt: _ctx.receiptBlock,
                            settingsBlock: _ctx.settingsBlock,
                            headerCards: _ctx.headerCards,
                            campaignBlocks: _ctx.campaignBlocks,
                            usabillaBlock: _ctx.usabillaBlock
                          }, null, 8, ["contentUrl", "calculatorInfoBlock", "contentBlocks", "cardReceipt", "settingsBlock", "headerCards", "campaignBlocks", "usabillaBlock"]))
                        : (_ctx.isHouse)
                          ? (_openBlock(), _createBlock(_component_buyHouseComponent, {
                              key: 4,
                              productName: _ctx.productName,
                              contentUrl: _ctx.model.url,
                              calculatorInfoBlock: _ctx.calculatorInfoBlock,
                              contentBlocks: _ctx.contentBlocks,
                              cardReceipt: _ctx.receiptBlock,
                              settingsBlock: _ctx.settingsBlock,
                              headerCards: _ctx.headerCards,
                              campaignBlocks: _ctx.campaignBlocks,
                              usabillaBlock: _ctx.usabillaBlock
                            }, null, 8, ["productName", "contentUrl", "calculatorInfoBlock", "contentBlocks", "cardReceipt", "settingsBlock", "headerCards", "campaignBlocks", "usabillaBlock"]))
                          : (_ctx.isAccident)
                            ? (_openBlock(), _createBlock(_component_buyAccidentComponent, {
                                key: 5,
                                contentUrl: _ctx.model.url,
                                calculatorInfoBlock: _ctx.calculatorInfoBlock,
                                contentBlocks: _ctx.contentBlocks,
                                cardReceipt: _ctx.receiptBlock,
                                settingsBlock: _ctx.settingsBlock,
                                headerCards: _ctx.headerCards,
                                campaignBlocks: _ctx.campaignBlocks,
                                usabillaBlock: _ctx.usabillaBlock
                              }, null, 8, ["contentUrl", "calculatorInfoBlock", "contentBlocks", "cardReceipt", "settingsBlock", "headerCards", "campaignBlocks", "usabillaBlock"]))
                            : (_ctx.isAccidentChildren)
                              ? (_openBlock(), _createBlock(_component_buyAccidentChildrenComponent, {
                                  key: 6,
                                  contentUrl: _ctx.model.url,
                                  calculatorInfoBlock: _ctx.calculatorInfoBlock,
                                  contentBlocks: _ctx.contentBlocks,
                                  cardReceipt: _ctx.receiptBlock,
                                  settingsBlock: _ctx.settingsBlock,
                                  headerCards: _ctx.headerCards,
                                  campaignBlocks: _ctx.campaignBlocks,
                                  usabillaBlock: _ctx.usabillaBlock
                                }, null, 8, ["contentUrl", "calculatorInfoBlock", "contentBlocks", "cardReceipt", "settingsBlock", "headerCards", "campaignBlocks", "usabillaBlock"]))
                              : (_ctx.isFamily)
                                ? (_openBlock(), _createBlock(_component_buyFamilyComponent, {
                                    key: 7,
                                    contentUrl: _ctx.model.url,
                                    calculatorInfoBlock: _ctx.calculatorInfoBlock,
                                    contentBlocks: _ctx.contentBlocks,
                                    cardReceipt: _ctx.receiptBlock,
                                    settingsBlock: _ctx.settingsBlock,
                                    headerCards: _ctx.headerCards,
                                    campaignBlocks: _ctx.campaignBlocks,
                                    usabillaBlock: _ctx.usabillaBlock
                                  }, null, 8, ["contentUrl", "calculatorInfoBlock", "contentBlocks", "cardReceipt", "settingsBlock", "headerCards", "campaignBlocks", "usabillaBlock"]))
                                : (_ctx.isBasket)
                                  ? (_openBlock(), _createBlock(_component_BasketComponent, {
                                      key: 8,
                                      contentUrl: _ctx.model.url,
                                      contentBlocks: _ctx.contentBlocks,
                                      cardReceipt: _ctx.receiptBlock,
                                      settingsBlock: _ctx.settingsBlock,
                                      headerCards: _ctx.headerCards,
                                      campaignBlocks: _ctx.campaignBlocks,
                                      usabillaBlock: _ctx.usabillaBlock
                                    }, null, 8, ["contentUrl", "contentBlocks", "cardReceipt", "settingsBlock", "headerCards", "campaignBlocks", "usabillaBlock"]))
                                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.cms)
          ? (_openBlock(), _createBlock(_component_MessageComponent, {
              key: 0,
              alertBlock: _ctx.alertBlock,
              class: "page__content vertical-app vertical-flow"
            }, null, 8, ["alertBlock"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          (_ctx.cms)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createVNode(_component_ContactComponent, {
                  class: "vertical-app vertical-flow contact",
                  useBasketModel: _ctx.isBasket,
                  productName: _ctx.productName
                }, null, 8, ["useBasketModel", "productName"]),
                (!_ctx.isBasket)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _createVNode(_component_LinkComponent, {
                        class: "iconLink iconLink__download iconLink__download--light",
                        to: _ctx.cms.ipidLink,
                        target: "_blank",
                        rel: "noopener",
                        tabindex: "-1",
                        externalIcon: false
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.cms.ipidText), 1)
                        ]),
                        _: 1
                      }, 8, ["to"]),
                      _createVNode(_component_LinkComponent, {
                        class: "iconLink iconLink__download iconLink__download--light",
                        to: _ctx.cms.conditionsLink,
                        target: "_blank",
                        rel: "noopener",
                        tabindex: "-1",
                        isExternal: false
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.cms.conditionsText), 1)
                        ]),
                        _: 1
                      }, 8, ["to"]),
                      (_ctx.cms.conditionsLink1)
                        ? (_openBlock(), _createBlock(_component_LinkComponent, {
                            key: 0,
                            class: "iconLink iconLink__download iconLink__download--light",
                            to: _ctx.cms.conditionsLink1,
                            target: "_blank",
                            rel: "noopener",
                            tabindex: "-1",
                            externalIcon: false
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.cms.conditionsText1), 1)
                            ]),
                            _: 1
                          }, 8, ["to"]))
                        : _createCommentVNode("", true),
                      (_ctx.cms.ipidLink1)
                        ? (_openBlock(), _createBlock(_component_LinkComponent, {
                            key: 1,
                            class: "iconLink iconLink__download iconLink__download--light",
                            to: _ctx.cms.ipidLink1,
                            target: "_blank",
                            rel: "noopener",
                            tabindex: "-1",
                            externalIcon: false
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.cms.ipidText1), 1)
                            ]),
                            _: 1
                          }, 8, ["to"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.usabillaProductBlock)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createVNode(_component_usabillaInPageComponent, {
                  class: _normalizeClass('productUsabilla'),
                  model: _ctx.usabillaProductBlock
                }, null, 8, ["model"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.cms)
            ? (_openBlock(), _createBlock(_component_cookieFooter, { key: 2 }))
            : _createCommentVNode("", true)
        ])
      ])
    ], 512), [
      [_vShow, _ctx.renderPage]
    ])
  ]))
}